import { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/UserManagement.css";
import "react-datepicker/dist/react-datepicker.css";
import { API_URL } from "../../config";
import axios from "axios";
import DatePicker from "react-datepicker";
import LoadingSpinner from "../../components/LoadingSpinner";
import useDoubleScroll from "../../helpers/useDoubleScroll";

const LoginHistory = () => {
  const [users, setUsers] = useState([]);
  const [userName, setUserName] = useState("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [total, setTotal] = useState(0);
  const limit = 100;
  const token = localStorage.getItem("authToken");

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleChange = (dates) => {
    if (!dates) {
      setStartDate(null);
      setEndDate(null);
      return;
    }

    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";

    const date = new Date(dateStr);
    if (isNaN(date)) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const fetchLoginHistory = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}loginHistory`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          limit,
          page,
          ...(userName && { user_fullname: userName }),
          ...(startDate &&
            endDate && {
            sdate: formatDate(startDate),
            edate: formatDate(endDate),
          }),
        },
      });
      setUsers(response.data.data.data);
      const count =
        startDate && endDate
          ? response.data.data.filteredCount
          : response.data.data.totalCount;

      setPageCount(Math.ceil(count / limit));
      setTotal(count);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchLoginHistory();
  }, [page, startDate, endDate, userName]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= pageCount) {
      setPage(newPage);
    }
  };

  const start = (page - 1) * limit + 1;
  const end = Math.min(page * limit, total);

  const tableContainerRef = useRef(null);
  const fakeContainerRef = useDoubleScroll(tableContainerRef);

  const formatDateTime = (datetimeString) => {
    const date = new Date(datetimeString);
    if (isNaN(date.getTime())) return "Invalid Date";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12; // Convert to 12-hour format
    const hourStr = String(hours).padStart(2, "0");

    return `${day}-${month}-${year} ${hourStr}:${minutes} ${ampm}`;
  };

  useEffect(() => {
    const handleClearDateFilters = () => {
      setStartDate(null);
      setEndDate(null);
      setUserName("");
    };

    window.addEventListener(
      "clearLoginHistoryDateFiltersEvent",
      handleClearDateFilters
    );

    return () => {
      window.removeEventListener(
        "clearLoginHistoryDateFiltersEvent",
        handleClearDateFilters
      );
    };
  }, []);


  return (
    <div className="panel-content mt-5">
      {/* {loading && <LoadingSpinner />} */}
      <div className="panel-heading d-flex justify-content-between align-items-center">
        <div className="panel-heading border-0">
          <h4 className="panel-title">Manage Login History</h4>
        </div>
        <div>
          <button
            className="btn btn-default btn-sm me-2"
          // onClick={handleExportExcel}
          >
            Export Excel
          </button>
          <span style={{ fontSize: "0.8rem" }} className="me-2">
            {start} to {end} of {total}
          </span>
          <button
            className="btn btn-default btn-sm"
            title="Previous"
            onClick={() => handlePageChange(page - 1)}
            disabled={page === 1}
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
          &nbsp;
          <button
            className="btn btn-default btn-sm"
            title="Next"
            onClick={() => handlePageChange(page + 1)}
            disabled={page === pageCount}
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
      </div>
      <div className="panel panel-default with-rounded-corner with-shadow">
        <div
          className="large-table-fake-top-scroll-container-3"
          ref={fakeContainerRef}
        >
          <div>&nbsp;</div>
        </div>

        <div className="large-table-container-3 user-table-container" ref={tableContainerRef}>
          <style>
            {`
                  .user-table-container {
                    position: relative;
                    max-height: 71vh;
                    overflow-y: auto;
                    overflow-x: auto;
                   }

                  /* First header row (titles) */
                  .user-table-container table thead tr:nth-child(1) th {
                    position: sticky;
                    top: 0;
                    z-index: 30;
                    background: #f8f9fa;
                  }

                 /* Second header row (search inputs) */
                 .user-table-container table thead tr:nth-child(2) th {
                   position: sticky;
                   top: 25px; /* adjust based on header height */
                   z-index: 25;
                   background: #fff;
                  }

                  .user-table-container table {
                    border-collapse: separate !important;
                    border-spacing: 0 !important;
                  }
               `}
          </style>
          <table className="table table-condensed table-hover bg-white">
            <thead>
              <tr>
                <th className="text-center">#</th>
                <th>User Name</th>
                <th>IP Address</th>
                <th>Device</th>
                <th>Operating System</th>
                <th>Browser</th>
                <th>SignIn Time</th>
                <th>SignOut Time</th>
              </tr>
              <tr>
                <th></th>
                <th>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="User name"
                    value={userName}
                    onChange={(e) => {
                      setPage(1); // reset page
                      setUserName(e.target.value);
                    }}
                  />
                </th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>

                <th>
                  <DatePicker
                    selected={startDate}
                    onChange={handleChange}
                    startDate={startDate}
                    endDate={endDate}
                    selectsRange
                    isClearable
                    placeholderText="Select a date range"
                    showYearDropdown
                    showMonthDropdown
                    dropdownMode="select"
                    dateFormat="yyyy-MM-dd"
                    className="form-control form-control-sm me-2"
                    yearDropdownItemNumber={10}
                    scrollableYearDropdown
                  />
                </th>
                <th></th>

              </tr>

            </thead>
            <tbody>
              {loading ? (
                Array.from({ length: 8 }).map((_, index) => (
                  <tr key={index} className="skeleton-row">
                    <td className="text-center"><div className="skeleton-box" /></td>
                    <td><div className="skeleton-box" /></td>
                    <td><div className="skeleton-box" /></td>
                    <td><div className="skeleton-box" /></td>
                    <td><div className="skeleton-box" /></td>
                    <td><div className="skeleton-box" /></td>
                    <td><div className="skeleton-box" /></td>
                    <td><div className="skeleton-box" /></td>
                  </tr>
                ))
              ) : Array.isArray(users) && users.length > 0 ? (
                users.map((user, index) => {
                  const signinTime = user.signin_time;
                  const signoutTime = user.signout_time;

                  const signin = signinTime
                    ? formatDateTime(signinTime)
                    : "N/A";

                  let signout = "Signed In";
                  if (signoutTime && signoutTime !== "0000-00-00 00:00:00") {
                    signout = formatDateTime(signoutTime);
                  }
                  return (
                    <tr key={user.id}>
                      <td className="text-center">
                        {(page - 1) * limit + index + 1}
                      </td>
                      <td>{user.user_fullname}</td>
                      <td>{user.ip_address}</td>
                      <td>{user.device_type}</td>
                      <td>{user.os_type}</td>
                      <td>{user.browser_type}</td>
                      <td>{signin}</td>
                      <td>{signout}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center" }}>
                    No Records Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default LoginHistory;
